var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"26","height":"26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20 5H6l5 8v5l4 3v-8l5-8z","stroke":"var(--color-primary)","stroke-width":"1.5","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }